import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    applicationID: '',
    user: null,
    storage: 'sessionstorage',
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setApplicationID: (state,action) => {
            state.applicationID = action.payload.applicationID
        },
        setUser: (state,action) => {
            const user = action.payload.user
            const newUser = {
                firstname: user.attributes['custom:firstname'],
                lastname: user.attributes['custom:lastname'],
                email: user.attributes.email,
                phone_number: user.attributes.phone_number,
                user_group: user.signInUserSession.accessToken.payload["cognito:groups"][0],
                email_verified: user.attributes.email_verified,
                phone_number_verified: user.attributes.phone_number_verified,
                stripe_id: user.stripe_id,
                subscription_id: user.subscription_id,
                subscription_status: user.subscription_status
            }
            state.user = {...newUser}
        },
        setStorage: (state,action) => {
            state.storage = action.payload.storage
        },
        reset: state => initialState,
    },
})

export const { setApplicationID, setUser, setStorage, reset } = userSlice.actions
export default userSlice.reducer